import { useEffect, useState } from 'react';
import { toString as qrToString } from 'qrcode';

/**
 * A QR code drawn as inline SVG, crisp on screen and on paper.
 *
 * The markup comes from the qrcode library and goes in with dangerouslySetInnerHTML. That is safe
 * because the library turns its input into geometry and never echoes it: proved, against hostile
 * input, by apps/admin/src/components/qr-safety.test.ts. Keep it that way — never interpolate
 * anything into this string yourself.
 */
export function QrCode({ value, size = 128 }: { value: string; size?: number }) {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void qrToString(value, { type: 'svg', margin: 1, width: size, errorCorrectionLevel: 'M' }).then(
      (s) => {
        if (alive) setSvg(s);
      },
    );
    return () => {
      alive = false;
    };
  }, [value, size]);
  if (!svg) return <div style={{ width: size, height: size, margin: '0 auto' }} />;
  return (
    <div
      role="img"
      aria-label={`QR code for ${value}`}
      style={{ width: size, height: size, margin: '0 auto' }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
